"use client";

import { useRouter } from "next/navigation";
import { AppButton } from "@/components/ui/Button";
import { fevicolInhomzRootRoute } from "../../_constants/tempRootRoute";

// The only interactive bit of ArticlesSection.jsx (a Server Component) —
// used twice (mobile + desktop layouts) for the same navigation action.
export default function ArticlesViewMoreButton() {
  const router = useRouter();

  return (
    <AppButton
      label="View more stories"
      variant="outlined"
      typographyClass="m3-label-large font-manrope"
      onClick={() => router.push(`${fevicolInhomzRootRoute}/blogs`)}
      sx={{
        borderColor: "var(--colorSecondarySecondary)",
        color: "var(--textSecondarySecondary)",
        borderRadius: "var(--radius100)",
        fontWeight: 600,
        "&:hover": {
          borderColor: "var(--colorSecondarySecondary)",
          backgroundColor: "var(--colorSurfaceSurfaceVar)",
        },
      }}
    />
  );
}
